import { gsap } from 'gsap';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';

gsap.registerPlugin(ScrollToPlugin);

export const scrollToDisclaimerText = (reference: string, isAutoScrollingRef: React.MutableRefObject<boolean>) => {
	//Activamos el autoscroll para que no haya problemas
	isAutoScrollingRef.current = true;

	//Guardamos la posición inicial
	const initialScrollPosition = window.pageYOffset || document.documentElement.scrollTop;

	//El footer de legales ya no usa <dl><dt><dd>, ahora es <ol data-component="disclaimer"><li><span>N.</span><div>texto</div></li></ol>
	const allItems = document.querySelectorAll('ol[data-component="disclaimer"] > li');

	for (const li of Array.from(allItems)) {
		//El número del legal es el primer hijo del li (span con texto "2.")
		const numberEl = li.firstElementChild;

		if (numberEl?.textContent?.trim() === `${reference}.`) {
			//El segundo hijo del li contiene el texto del legal
			const textWrap = li.children[1] as HTMLElement | undefined;

			if (textWrap) {
				//Ahora cogemos el contenedor del mensaje del legal para añadirle el (volver arriba)
				if (!textWrap.querySelector('.back-to-top')) {
					const span = document.createElement('span');
					span.className = 'back-to-top';
					span.style.cssText = 'display:block;cursor:pointer;color:inherit;text-decoration:underline;font-weight:bold;';
					span.textContent = '↑ Volver arriba';
					span.onclick = () => {
						//Activamos el auto scroll para volver al legal y desactiamos el autoscroll al pasar 1500ms
						window.scrollTo({
							top: initialScrollPosition,
							behavior: 'smooth',
						});
						span.remove();
					};
					textWrap.appendChild(span);
				}

				//Obtenemos la posicion del legal en la lista
				const rect = li.getBoundingClientRect();
				//Obtenemos cuanto se ha scrolleado ya para tenerlo en cuenta
				const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
				//Hacemos scroll automatico con 100 px de margen
				window.scrollTo({
					top: scrollTop + rect.top - 100,
					behavior: 'smooth',
				});
				//Hacemos focus en el legal
				setTimeout(() => {
					li.setAttribute('tabindex', '-1');
					(li as HTMLElement).focus();
				}, 800);

				return;
			}
		}
	}
	isAutoScrollingRef.current = false;
};

export const handleModelListAutoScroll = (activeCarlineIndex: number, numberOfCarlines: number) => {
	const scrollContainer = document.getElementById('scroll-container');
	const lastModelElement = document.getElementById(`model-${numberOfCarlines - 1}`);

	if (!scrollContainer || !lastModelElement) return;

	const modelElementHeight = Number(
		lastModelElement?.getBoundingClientRect().height + lastModelElement?.style.marginTop,
	);

	//Hacemos scroll hasta el carline
	if (activeCarlineIndex >= 0 && scrollContainer) {
		const visibleElements = Math.floor(scrollContainer?.getBoundingClientRect().height / modelElementHeight);

		if (visibleElements && scrollContainer) {
			if (visibleElements < numberOfCarlines) {
				if (activeCarlineIndex > visibleElements / 2) {
					const marginTop = -1 * modelElementHeight * (activeCarlineIndex - visibleElements / 2);
					scrollContainer.style.marginTop = `${marginTop}px`;
				} else {
					scrollContainer.style.marginTop = `${modelElementHeight * 2}px`;
				}
			} else {
				scrollContainer.style.marginTop = `${modelElementHeight * 2}px`;
			}
		}
	}
};
